import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Loads from './pages/Loads';
import LoadDetail from './pages/LoadDetail';
import CreateLoad from './pages/CreateLoad';
import Drivers from './pages/Drivers';
import DriverDetail from './pages/DriverDetail';
import CreateDriver from './pages/CreateDriver';
import Dispatchers from './pages/Dispatchers';
import CreateDispatcher from './pages/CreateDispatcher';
import Payments from './pages/Payments';
import VehicleDetail from './pages/VehicleDetail';
import DispatcherDetail from './pages/DispatcherDetail';
import PaymentDetail from './pages/PaymentDetail';
import Clients from './pages/Clients';
import CreateClient from './pages/CreateClient';
import ClientDetail from './pages/ClientDetail';
import Paystub from './pages/Paystub';

// Checks if the user is logged in and redirects to the appropriate
// starting screen — /dashboard if logged in, /login if not.
function RootRedirect() {
  const token = localStorage.getItem('token');
  return <Navigate to={token ? '/dashboard' : '/login'} replace />;
}

function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/loads" element={<ProtectedRoute><Loads /></ProtectedRoute>} />
          <Route path="/loads/create" element={<ProtectedRoute><CreateLoad /></ProtectedRoute>} />
          <Route path="/loads/:id" element={<ProtectedRoute><LoadDetail /></ProtectedRoute>} />
          <Route path="/drivers" element={<ProtectedRoute><Drivers /></ProtectedRoute>} />
          <Route path="/drivers/create" element={<ProtectedRoute><CreateDriver /></ProtectedRoute>} />
          <Route path="/drivers/:id" element={<ProtectedRoute><DriverDetail /></ProtectedRoute>} />
          <Route path="/drivers/:id/paystub" element={<ProtectedRoute><Paystub /></ProtectedRoute>} />
          <Route path="/dispatchers" element={<ProtectedRoute><Dispatchers /></ProtectedRoute>} />
          <Route path="/dispatchers/create" element={<ProtectedRoute><CreateDispatcher /></ProtectedRoute>} />
          <Route path="/dispatchers/:id" element={<ProtectedRoute><DispatcherDetail /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
          <Route path="/payments/:id" element={<ProtectedRoute><PaymentDetail /></ProtectedRoute>} />
          <Route path="/vehicles/:id" element={<ProtectedRoute><VehicleDetail /></ProtectedRoute>} />
          <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
          <Route path="/clients/create" element={<ProtectedRoute><CreateClient /></ProtectedRoute>} />
          <Route path="/clients/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;